import React from 'react'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    layout?: 'half-half' | 's-l' | 'l-s' | 'thirds'
    divider?: React.ReactNode
  }
>

const FormRow = ({className, layout, children, divider, ...props}: Props) => (
  <div
    {...props}
    className={cn('FormRow', {[`layout-${layout}`]: !!layout, divider: !!divider}, className)}
  >
    {mapChildrenWithFragments(
      children,
      (child, index) =>
        child && (
          <React.Fragment key={index}>
            <div className="FormRow__column">{child}</div>
            {index === 0 && divider && <div className="FormRow__divider">{divider}</div>}
          </React.Fragment>
        )
    )}
  </div>
)

export default FormRow
